export default "__VITE_ASSET__75rJ6lle__"